import React from 'react';
import { ConfigProvider } from 'antd';
import { useTranslation } from './TranslationContext';
import { getAntdLocale } from './antdLocaleMap';

export function LocalizedAntdConfig({ theme, children }) {
  const { currentLang } = useTranslation();
  return (
    <ConfigProvider theme={theme} locale={getAntdLocale(currentLang)}>
      {children}
    </ConfigProvider>
  );
}
